/* ===== Anadita Luxe — cart drawer (AJAX) ===== */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var body = drawer.querySelector('[data-cart-body]');
  var foot = drawer.querySelector('[data-cart-foot]');
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  };

  function open(trigger) { if (window.AnaditaChrome) window.AnaditaChrome.open(drawer, trigger && typeof trigger.focus === 'function' ? trigger : undefined); }
  function close() { if (window.AnaditaChrome && window.AnaditaChrome.isOpen(drawer)) window.AnaditaChrome.close(); }
  window.AnaditaCart = { open: open, close: close, refresh: refresh };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle]');
    if (t) {
      if (!window.AnaditaChrome) return;
      e.preventDefault();
      open(t);
      refresh().catch(function () {});
      return;
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
  });

  function renderItems(cart) {
    var html = '';
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="button button--primary">Continue shopping</a></div>';
      if (foot) foot.setAttribute('hidden', '');
    } else {
      cart.items.forEach(function (item) {
        var img = item.image ? '<img src="' + item.image + '&width=160" alt="" loading="lazy">' : '';
        var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
        html += '<li class="cart-drawer__item" data-cart-item="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer__img media media--square">' + img + '</a>' +
          '<div class="cart-drawer__info"><a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' + variant +
          '<div class="qty-selector qty-selector--sm"><button type="button" data-cart-minus="' + item.key + '">&minus;</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-cart-qty="' + item.key + '"><button type="button" data-cart-plus="' + item.key + '">&plus;</button></div></div>' +
          '<div class="cart-drawer__price">' + money(item.final_line_price) + '<button class="cart-item__remove" data-cart-remove="' + item.key + '">Remove</button></div></li>';
      });
      body.innerHTML = '<ul class="cart-drawer__items" role="list">' + html + '</ul>';
      if (foot) foot.removeAttribute('hidden');
    }
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.hasAttribute('data-hide-when-empty')) el.hidden = cart.item_count === 0;
    });
    var sub = drawer.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    updateShipping(cart.total_price);
    renderCrossSell(cart);
  }

  function getCrossSellCandidates() {
    var el = document.querySelector('[data-cross-sell-candidates]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function renderCrossSell(cart) {
    var wrap = drawer.querySelector('[data-cross-sell]');
    if (!wrap) return;
    var candidates = getCrossSellCandidates();
    if (!candidates.length || !cart.items.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }

    var cartHandles = cart.items.map(function (i) { return i.handle; });
    var cartTypes = cart.items.map(function (i) { return (i.product_type || '').toLowerCase(); });
    var hasBangles = cartTypes.indexOf('bangles') !== -1;
    var hasNecklace = cartTypes.indexOf('necklace') !== -1;

    var eligible = candidates.filter(function (c) { return cartHandles.indexOf(c.handle) === -1; });

    // If cart already has one jewelry type, prefer showing the other type first.
    eligible.sort(function (a, b) {
      var aType = (a.product_type || '').toLowerCase(), bType = (b.product_type || '').toLowerCase();
      var aScore = 0, bScore = 0;
      if (hasBangles && !hasNecklace) { aScore = aType === 'necklace' ? 1 : 0; bScore = bType === 'necklace' ? 1 : 0; }
      if (hasNecklace && !hasBangles) { aScore = aType === 'bangles' ? 1 : 0; bScore = bType === 'bangles' ? 1 : 0; }
      return bScore - aScore;
    });

    var picks = eligible.slice(0, 2);
    if (!picks.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }

    var html = '<p class="cart-drawer__cross-sell-heading">Complete Your Look</p><div class="cart-drawer__cross-sell-grid">';
    picks.forEach(function (p) {
      html += '<a class="cross-sell-card" href="' + p.url + '">' +
        '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="80" height="100">' +
        '<span class="cross-sell-card__title">' + p.title + '</span>' +
        '<span class="cross-sell-card__price">' + money(p.price) + '</span>' +
        '</a>';
    });
    html += '</div>';
    wrap.innerHTML = html;
    wrap.hidden = false;
  }

  function updateShipping(total) {
    var wrap = drawer.querySelector('[data-free-shipping]'); if (!wrap) return;
    var threshold = parseInt(wrap.dataset.threshold, 10) || 0;
    var txt = wrap.querySelector('[data-free-shipping-text]');
    var bar = wrap.querySelector('[data-free-shipping-bar]');
    if (threshold <= 0) { wrap.style.display = 'none'; return; }
    if (total >= threshold) { txt.innerHTML = '🎉 You\'ve unlocked <strong>free US shipping!</strong>'; bar.style.width = '100%'; }
    else { txt.innerHTML = 'You\'re ' + money(threshold - total) + ' away from <strong>free shipping</strong>'; bar.style.width = Math.min(100, (total / threshold) * 100) + '%'; }
  }

  function refresh() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { renderItems(cart); return cart; }); }

  function change(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderItems);
  }
  drawer.addEventListener('click', function (e) {
    var m = e.target.closest('[data-cart-minus]'), p = e.target.closest('[data-cart-plus]'), rm = e.target.closest('[data-cart-remove]');
    if (m) { var i = drawer.querySelector('[data-cart-qty="' + m.dataset.cartMinus + '"]'); change(m.dataset.cartMinus, Math.max(0, (parseInt(i.value, 10) || 1) - 1)); }
    if (p) { var j = drawer.querySelector('[data-cart-qty="' + p.dataset.cartPlus + '"]'); change(p.dataset.cartPlus, (parseInt(j.value, 10) || 1) + 1); }
    if (rm) { e.preventDefault(); change(rm.dataset.cartRemove, 0); }
  });
  var note = drawer.querySelector('[data-cart-note]');
  if (note) note.addEventListener('change', function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); });

  // Hook quick-add + product form to open drawer
  document.addEventListener('anadita:added', function () { refresh().then(open); });
  refresh();
})();
